import React, { Component } from 'react'
import { Form } from 'react-bootstrap';
import loadScripts from '../../../dassets/js/custom';
class BankDetails extends Component {
    componentDidMount() {
      loadScripts();
    }
    constructor(props) {
        super(props);

        this.saveAndContinue = this.saveAndContinue.bind(this);
    }

    saveAndContinue(e) {
        e.preventDefault()

        // Get values via this.refs
        let data = {
            acct_type: this.refs.acct_type.value,
            bank_name: this.refs.bank_name.value,
            acct_name: this.refs.acct_name.value,
            acct_no: this.refs.acct_no.value,
            opening_date: this.refs.opening_date.value,
            bvn: this.refs.bvn.value,
        }

        this.props.saveValues(data)
        this.props.nextStep()
    }
    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="text-danger mb-4">Bank Details</h4>
                                <form onSubmit={this.saveAndContinue}>
                                    <div className="row">
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Account Type<span className="text-danger">*</span></label>
                                            <select ref="acct_type" required className="form-control" defaultValue={this.props.fieldValues.acct_type}>
                                                <option value="" hidden>Select...</option>
                                                <option value="Savings">Savings</option>
                                                <option value="Current">Current</option>
                                            </select>
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Bank Name<span className="text-danger">*</span></label>
                                            <Form.Control type="text" className="form-control" ref="bank_name" placeholder="Bank Name" defaultValue={this.props.fieldValues.bank_name} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Account Name<span className="text-danger">*</span></label>
                                            <Form.Control type="text" className="form-control" ref="acct_name" placeholder="Account Name" defaultValue={this.props.fieldValues.acct_name} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Account No<span className="text-danger">*</span></label>
                                            <Form.Control type="text" className="form-control uint" ref="acct_no" placeholder="Account No" defaultValue={this.props.fieldValues.acct_no} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Opening Date</label>
                                            <Form.Control type="date" className="form-control" ref="opening_date" placeholder="Opening Date" defaultValue={this.props.fieldValues.opening_date} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Bank Verification No<span className="text-danger">*</span></label>
                                            <Form.Control type="text" className="form-control uint" ref="bvn" placeholder="Bank Verification No" defaultValue={this.props.fieldValues.bvn} required />
                                        </Form.Group>
                                    </div>
                                    <button onClick={this.props.previousStep} type="button" className="btn btn-primary mr-2">Previous</button>
                                    <button type="submit" className="btn btn-primary mr-2">Save and Continue</button>
                                </form>
                            </div >
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default BankDetails;